var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXCircleRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.707 12.707L17.415 16l3.293 3.293a1 1 0 01-1.415 1.415L16 17.413l-3.293 3.293a1 1 0 01-1.415-1.415L14.587 16l-3.293-3.293a1 1 0 111.415-1.415L16 14.587l3.293-3.293a1 1 0 011.415 1.415zM29 16A13 13 0 1116 3a13.014 13.014 0 0113 13zm-2 0a11 11 0 10-11 11 11.012 11.012 0 0011-11z"
  })));
}
export default SvgXCircleRegular;